export const uk = {
    platform: 'Показывать',
    strategy: 'Стратегия'
};
